// extracted by mini-css-extract-plugin
export default {"news":"NewsPage_news__hQgbR","news__title":"NewsPage_news__title__xw5VU","news__subtitle":"NewsPage_news__subtitle__s8bLC","news__descr":"NewsPage_news__descr__iwMmN"};